var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"flex w-full flex-col gap-3"},[_c('div',{staticClass:"flex w-full items-center gap-2.5"},[_c('span',{staticClass:"text-xs text-gray-7"},[_vm._v(_vm._s(_vm.product))]),_vm._v(" "),_c('div',{staticClass:"fader h-[1px] w-1/2"})]),_vm._v(" "),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }